import useSWR from "swr"
import { useCsrfToken } from "./useCsrfToken"
import { fetchGraphqlQuery } from "common/lib/fetchGraphqlQuery"

export const useGraphqlQuery = <T>(
  query: string | null,
  variables?: Record<string, string | number | boolean>,
) => {
  // Callers pass a null query to skip it, for example `useViewer` for readers
  // with no session. Fetching a token for those would cost a request to Rails
  // on every page view, for a token nothing uses.
  const { token } = useCsrfToken(!!query)
  const shouldFetch = token && query
  const cacheKey = [query, token, variables]
  const {
    data,
    error,
    isLoading: loading,
  } = useSWR<T>(
    shouldFetch ? cacheKey : null,
    ([query, token, variables]) =>
      fetchGraphqlQuery(
        query,
        {
          "X-CSRF-Token": token,
        },
        variables,
      ),
    {},
  )

  return { loading, loaded: !!data && !loading, error, data }
}
